import styles from "./UserMessage.module.scss";

interface UserMessageProps {
  text: string;
}

export function UserMessage({ text }: UserMessageProps) {
  return (
    <div className={styles.root}>
      <p className={styles.text}>{text}</p>
    </div>
  );
}
